'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const PaginationButton = renderWithRef('PaginationButton', null, (o, s)=>{
    let a = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('PaginationButton', o, [
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(a)
        }
    ]);
    let { children: u, disabled: b = false, variant: l, accessibleText: f, as: y, component: O } = o, j = _object_without_properties(o, [
        "children",
        "disabled",
        "variant",
        "accessibleText",
        "as",
        "component"
    ]), m = f;
    a && !m && (m = a.t('next' === l ? 'pagination-button-next.accessible-text-for-icon' : 'pagination-button-previous.accessible-text-for-icon'));
    let _ = _object_spread_props(_object_spread({
        'aria-label': null != m ? m : void 0
    }, j), {
        disabled: ('button' === y || 'button' === O) && b,
        as: b && 'button' !== y && 'button' !== O && 'span' || y || O || 'a',
        role: 'button'
    }), d = [
        `swan-pagination-button-${l}`
    ];
    return b && d.push('swan-pagination-button-disabled'), jsx("li", {
        children: jsxs(RenderComp, {
            root: "a",
            classNames: d,
            forwardedRef: s,
            props: _,
            children: [
                'next' === l && jsx(Icon, {
                    iconType: "chevronRight"
                }),
                'previous' === l && jsx(Icon, {
                    iconType: "chevronLeft"
                }),
                u
            ]
        })
    });
});

export { PaginationButton };
